import React from 'react';
import BaseHeader from '../BaseHeader';
import { Box } from "@mui/material";
import HelpButton from '../HelpButton';
// import TagSearchSelect from '../TagSearchSelect';タグサーチは現状ログイン前提だからエラー出さんように隠しておく

function NotLoginHeader() {

    const loginOnClick = () => {
        window.location.href = '/login';
    };

    const registerOnClick = () => {
        window.location.href = '/register';
    };

    const linkBoxSx = {
        cursor: 'pointer',
        borderRadius: '3px',
        padding: '8px',
        transition: 'background-color 0.2s ease, color 0.2s ease',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.12)',
        },
        '&:active': {
            backgroundColor: 'rgba(255, 255, 255, 0.24)',
        },
        '&:focus-visible': {
            outline: '2px solid #ffffff',
            outlineOffset: '2px',
        },
    };

    return (
        <BaseHeader>
            <Box
                sx={{ ...linkBoxSx, width: '80px' }}
                onClick={() => loginOnClick()}
            >
                ログイン
            </Box>
            <Box
                sx={{ ...linkBoxSx, width: '80px' }}
                onClick={() => registerOnClick()}
            >
                新規登録
            </Box>
            <Box sx={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '8px' }}>
                {/* <TagSearchSelect /> */}
                <HelpButton />
            </Box>
        </BaseHeader>

    );
}

export default NotLoginHeader;
